import { render, staticRenderFns } from "./platform_badge.vue.js?vue&type=template&id=1faf412a!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./platform_badge.vue?vue&type=template&id=1faf412a"
import script from "./platform_badge.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./platform_badge.vue?vue&type=script&lang=js"
export * from "./platform_badge.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./platform_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports